/*
 * COPYRIGHT 2022 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 *
 */

export class ButtonPanelStyles {
    static STYLES = Object.freeze({
        main: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            padding: '0px',
            gap: '10px'
        }
    });

    static getMain() {
        return ButtonPanelStyles.STYLES.main;
    }
}
